<script lang="ts">
    import { _ } from "svelte-i18n"
    import FormInputText from "../../../widgets/Form/FormInputText.svelte"
    import FormInputCheckbox from "../../../widgets/Form/FormInputCheckbox.svelte"

    let {
        product,
        user_inputs = $bindable(),
    }: {
        product: Product
        user_inputs: CartUserInputs
    } = $props()

    let randomKeyNumber = $state(false)
    $effect(() => {
        if (randomKeyNumber) user_inputs.key_number = -1
        else user_inputs.key_number = null
    })
</script>

<form class="gravur_fields">
    <div class="row">
        {#if product.user_inputs?.key_number_range_from && product.user_inputs.key_number_range_to}
            {#if product.user_inputs?.key_number_random_ok}
                <div class="col-md-12">
                    <FormInputCheckbox bind:checked={randomKeyNumber} label={$_("product.any-key-number")} />
                </div>
            {/if}
            {#if !randomKeyNumber}
                <div class="col-md-12">
                    <FormInputText
                        name="schluesselnummer"
                        label={$_("product.key-number")}
                        bind:value={user_inputs.key_number}
                        type="number"
                        min={product.user_inputs?.key_number_range_from}
                        max={product.user_inputs?.key_number_range_to}
                        step={1}
                        decimals={0}
                    />
                    <div class="infotext">
                        {$_("product.key-number-in-range-from")}
                        <span class="num">{product.user_inputs?.key_number_range_from}</span>
                        {$_("product.key-number-in-range-to")}
                        <span class="num">{product.user_inputs?.key_number_range_to}</span>
                    </div>
                </div>
            {/if}
        {/if}
    </div>
</form>
